import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {combineReducers} from 'redux';

// Components
import LicensePrototype from './LicensePrototype';

// Reducers
import licensePrototypeReducer from './LicensePrototype/store/licensePrototypeReducer';

const hasPermission = (permission, permissions) => {
    return permissions.includes(permission) || permissions.includes('*');
};

// Routes
export const routes = (basePath, permissions) =>
    <Switch>
        {hasPermission('license_prototype', permissions) ?
            < Route path={basePath} exact component={LicensePrototype}/> : null}
    </Switch>;


export const reducers = combineReducers({
    licensePrototypes: licensePrototypeReducer
});